// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueChatScroll from 'vue-chat-scroll'
import firebase from 'firebase'
import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
import CircularCountDownTimer from "vue-circular-count-down-timer";


// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
 
// Tell Vue to install the plugin.
Vue.use(CircularCountDownTimer);
Vue.use(VuejsDialog);
Vue.use(VueChatScroll)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

let app = null

// what for firebase auth to init before creating into app
firebase.auth().onAuthStateChanged(() => {

  // init app if not aleardy created
  if (!app){
    app = new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
}
  

})



// WEBPACK FOOTER //
// ./src/main.js